<template>
  <SEmpty data-test="no-access-empty">
    <SEmptyHeader>
      <SEmptyMedia variant="icon">
        <i
          class="s-icon s-icon--lock"
          style="--s-icon-size: 1.5rem"
          aria-hidden="true"
        />
      </SEmptyMedia>
      <SEmptyTitle>{{ t("error.no-access-for-role") }}</SEmptyTitle>
      <SEmptyDescription>
        {{ t("error.insufficient-permissions") }}
      </SEmptyDescription>
    </SEmptyHeader>
  </SEmpty>
</template>

<!--
  @component NoAccessEmpty
  Shown in place of a list when the seller's role carries no Elasticsearch
  token for it, so the screen says why instead of looking empty.

  @example
  <NoAccessEmpty v-if="!hasAccess" />
-->
<script setup lang="ts">
import { useI18n } from "vue-i18n";

import {
  SEmpty,
  SEmptyDescription,
  SEmptyHeader,
  SEmptyMedia,
  SEmptyTitle,
} from "@smeetz/ui-core/s-empty";
import "@smeetz/ui-icons/lock/style.css";

const { t } = useI18n({ useScope: "global" });
</script>
